NtechApp.MultipleJobForm = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;
    this._contactField = null;

    this._$jobsNav = null;
    this._$jobsField = null;
    this._positionSelect = null;

    this._formCaptions = [];
    this._formFields = {};
    this._formSaver = null;

    this._$selectedNavItem = null;

    this._formOldVals = {};

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();
        me._contactField = new NtechApp.JobFormContactField($view, "#multiple_job_contactText");

        me._$jobsNav = me._$view.find(".multipleJobsFormNavField");
        me._$jobsField = me._$view.find(".multipleJobsFormField");
        me._positionSelect = NtechApp.formManager.getFormSelectById("positionJobFilter");

        var $formView = me._$view.find("[data-saveManagerForm]");
        me._formSaver = new NtechApp.FormSaver(
            $formView,
            $formView.attr("data-saveManagerForm"),
            $formView.attr("data-saveManagerFormRedirect")
        );
        me._formSaver.setOnError(function(errors) {
            me._showErrors.call(me, errors);
        });

        me._collectJobFormFields();
        me._collectJobFormLabels();

        me._bindEvents();
    }

    this._bindEvents = function() {
        $(me._formSaver).on(NtechApp.FormSaver.EVENT_POSTSET_FORMDATA, function(event, requestData) {
            me._syncCurrentTabFormVals();
            me._syncRequestData(requestData);
        });

        $(me._positionSelect).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function(e, labels, vals) {
            me._saveFormOldVals();
            //me._reinitFormVals(labels, vals);
            me._updateJobsFormVisibility(labels, vals);

            var navItems = me._createPositionNav(labels, vals);
            me._$selectedNavItem = navItems[0];
            me._createFormVals(navItems);

            if(vals.length > 0)
                me._updateSublabels();
        });

        me._click.listen(me._$jobsNav, ".listItem", function(event) {
            var $listItem = $(event.target).closest(".listItem");
            me._$selectedNavItem.removeClass("error");
            $listItem.removeClass("error");

            if(me._$selectedNavItem.attr("data-listVal") == $listItem.attr("data-listVal"))
                return;

            me._switchPositionTab($listItem);
            me._updateSublabels();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.MultipleJobForm, {
    _getDescriptionField: function() {
        return this._$jobsField.find("#multiple_job_description");
    },

    _collectJobFormFields: function() {
        var $description = this._getDescriptionField();
        var employmentJobFilter = NtechApp.formManager.getRadioBoxById("employmentJobFilter");
        var $salary = this._$jobsField.find("#multiple_job_salary");
        var salaryType = NtechApp.formManager.getRadioBoxById("salaryType");

        this._formFields["description"] = {
            field: $description, initVal: $description.val(), formVals: {}
        };
        this._formFields["employmentJobFilter"] = {
            field: employmentJobFilter, initVal: employmentJobFilter.val(), formVals: {}
        };
        this._formFields["salary"] = {
            field: $salary, initVal: $salary.val(), formVals: {}
        };
        this._formFields["salaryType"] = {
            field: salaryType, initVal: salaryType.val(), formVals: {}
        }
    },

    _collectJobFormLabels: function() {
        var $descriptionLabel = this._$jobsField.find("label[for='multiple_job_description']");
        var $employmentLabel = this._$jobsField.find("label[for='multiple_job_employmentJobFilter']");
        var $salaryLabel = this._$jobsField.find("label[for='multiple_job_salary']");

        this._formCaptions = [$descriptionLabel.parent(), $employmentLabel.parent(), $salaryLabel.parent()];
        for(var i = 0; i < this._formCaptions.length; i++) {
            this._formCaptions[i].addClass("semilongCaption");

            var $positionLabel = $("<div/>").addClass("sublabel positionLabel");
            $positionLabel.append($("<span/>").text("for position"));
            this._formCaptions[i].append($positionLabel);

            //var $copyLabel = $("<div/>").addClass("sublabel copyLabel");
            //$copyLabel.append($("<span/>").text("copy to all positions"));
            //this._formCaptions[i].append($copyLabel);
        }

        //this._bindJobFormCopyEvent(this._formCaptions[0].find(".copyLabel"), ["description"]);
        //this._bindJobFormCopyEvent(this._formCaptions[1].find(".copyLabel"), ["employmentJobFilter"]);
        //this._bindJobFormCopyEvent(this._formCaptions[2].find(".copyLabel"), ["salary", "salaryType"]);
        this._bindJobFormCopyEvent(this._$view.find("#copyDescriptions"), ["description"]);
    },

    _bindJobFormCopyEvent: function($copyButton, fieldsToUpdate) {
        var me = this;
        me._click.listen($copyButton, function() {
            for(var fieldName in me._formFields) {
                var fieldData = me._formFields[fieldName];
                var $field = fieldData.field;

                var shouldUpdate = false;
                for(var i = 0; i < fieldsToUpdate.length; i++) {
                    if(fieldsToUpdate[i] == fieldName) {
                        shouldUpdate = true;
                        break;
                    }
                }

                if(!shouldUpdate)
                    continue;

                for(var formVal in fieldData.formVals) {
                    fieldData.formVals[formVal].val = $field.val();
                }
            }

            var label = "Description";
            //var label = $copyButton.closest(".caption").find("label").text().replace("*", "");
            NtechApp.info.on(label + " field copied to all positions");
        });
    },

    _reinitFormVals: function(labels, vals) {
        for(var prop in this._formFields) {
            var data = this._formFields[prop];
            data.field.val(data.initVal);
        }
    },

    _updateJobsFormVisibility: function(labels, vals) {
        if(vals.length == 0) {
            this._$jobsNav.css("display", "none");
            this._$jobsField.css("display", "none");
        }
        else {
            this._$jobsNav.css("display", "block");
            this._$jobsField.css("display", "block");
        }
    },

    _createPositionNav: function(labels, vals) {
        this._$jobsNav.find(".listItem").remove();
        var navItems = [];

        for(var i = 0; i < labels.length; i++) {
            var $listItem = $("<div/>").addClass("listItem");
            $listItem.text((i + 1) + "." + labels[i]).attr("data-listVal", vals[i]);
            $listItem.attr("data-listLabel", labels[i]);

            if(i == 0) {
                $listItem.addClass("selected");
            }

            navItems.push($listItem);
            $listItem.insertBefore(this._$jobsNav.find(".listLastItem"));
        }

        return navItems;
    },

    _saveFormOldVals: function() {
        // Save old vals
        var oldData = {};
        for(var fieldName in this._formFields) {
            oldData[fieldName] = {formVals: {}};

            for(var formVal in this._formFields[fieldName].formVals) {
                var oldFormVals = this._formFields[fieldName].formVals[formVal];
                oldData[fieldName].formVals[formVal] = oldFormVals;
            }
        }

        this._syncCurrentTabFormVals();

        this._formOldVals = oldData;
    },

    _syncCurrentTabFormVals: function() {
        if(this._$selectedNavItem != null) {
            var selectedVal = this._$selectedNavItem.attr("data-listVal");
            for(var fieldName in this._formFields) {
                var fieldData = this._formFields[fieldName];
                var fieldVal = fieldData.field.val();

                for(var formVal in fieldData.formVals) {
                    if(formVal == selectedVal) {
                        fieldData.formVals[formVal].val = fieldVal;
                    }
                }
            }
        }
    },

    _createFormVals: function(listItems) {
        for(var fieldName in this._formFields) {
            var fieldData = this._formFields[fieldName];

            for(var i = 0; i < listItems.length; i++) {
                var label = listItems[i].attr("data-listLabel");
                var val = listItems[i].attr("data-listVal");

                // Disable oldVal to disable prev position syncs
                var oldVal = this._getOldFormVal(fieldName, val, this._formOldVals);
                var fieldVal = (oldVal == null) ? fieldData.initVal : oldVal;

                fieldData.formVals[val] = {label: label, val: fieldVal};
                // Disable next line too to disable prev position syncs
                if(val == this._$selectedNavItem.attr("data-listVal"))
                    fieldData.field.val(fieldData.formVals[val].val);
            }
        }
    },

    _getOldFormVal: function(fieldName, val, oldData) {
        for(var oldDataFieldName in oldData) {
            if(oldDataFieldName != fieldName)
                continue;

            var oldDataVals = oldData[oldDataFieldName].formVals;
            for(var formVal in oldDataVals) {
                if(formVal == val)
                    return oldDataVals[formVal].val;
            }
        }

        return null;
    },

    _updateSublabels: function() {
        var label = this._$selectedNavItem.attr("data-listLabel").toLowerCase();
        for(var i = 0; i < this._formCaptions.length; i++) {
            this._formCaptions[i].find(".positionLabel span").text("for " + label + " position");
        }

        this._getDescriptionField().attr("placeholder", "Please enter description for " + label + " position");
    },

    _switchPositionTab: function($listItem) {
        var currentVal = this._$selectedNavItem.attr("data-listVal");
        // Save current tab
        for(var fieldName in this._formFields) {
            var fieldData = this._formFields[fieldName];

            for(var formVal in fieldData.formVals) {
                if(formVal == currentVal) {
                    fieldData.formVals[formVal]["val"] = fieldData.field.val();
                }
            }
        }

        var newVal = $listItem.attr("data-listVal");
        // Load new tab
        for(var fieldName in this._formFields) {
            var fieldData = this._formFields[fieldName];
            var $field = fieldData.field;

            for(var formVal in fieldData.formVals) {
                if(formVal == newVal) {
                    $field.val(fieldData.formVals[formVal]["val"]);
                }
            }
        }

        this._$jobsNav.find(".listItem").removeClass("selected");
        $listItem.addClass("selected");

        this._$selectedNavItem = $listItem;
    },

    _syncRequestData: function(requestData) {
        var modelFormData = requestData.modelFormData;
        var positionsData = [];

        if(NtechApp.dom.hasOwnProp(modelFormData, "positionJobFilter") &&
            NtechApp.dom.isArray(modelFormData["positionJobFilter"])) {
            for(var i = 0; i < modelFormData["positionJobFilter"].length; i++) {
                var positionId = modelFormData["positionJobFilter"][i]["id"];
                var positionData = this._getPositionSharedData(modelFormData);
                positionData["positionJobFilter"] = positionId;

                for(var fieldName in this._formFields) {
                    for(var positionVal in this._formFields[fieldName].formVals) {
                        if(positionVal == positionId) {
                            var fieldVal = this._formFields[fieldName].formVals[positionVal].val;
                            positionData[fieldName] = fieldVal;
                        }
                    }
                }

                positionsData.push(positionData);
            }

            requestData.modelFormData = positionsData;
        }
        else {
            var err = {noPositionsSelected: "Please select at least 1 position."};
            this._formSaver.showErrors(err);
            this._formSaver.stop();
            this._formSaver.cancelRequest();
        }
    },

    _getPositionSharedData: function(modelFormData) {
        var data = {};
        for(var prop in modelFormData) {
            if(prop == "positionJobFilter")
                continue;

            data[prop] = modelFormData[prop];
        }

        return data;
    },

    _showErrors: function(errors) {
        var uniqueFieldNames = [];
        for(var fieldName in this._formFields)
            uniqueFieldNames.push(fieldName);

        var isSharedError = function(errName) {
            for(var i = 0; i < uniqueFieldNames.length; i++) {
                if(errName == uniqueFieldNames[i])
                    return false;
            }

            return true;
        };

        var sharedErrors = {};
        var uniqueErrors = {};
        for(var positionId in errors) {
            var positionErrors = errors[positionId];

            for(var errName in positionErrors) {
                var errValue = positionErrors[errName];
                if(isSharedError(errName)) {
                    sharedErrors[errName] = errValue;
                    continue;
                }

                if(!NtechApp.dom.hasOwnProp(uniqueErrors, positionId))
                    uniqueErrors[positionId] = {};

                uniqueErrors[positionId][errName] = errValue;
            }
        }

        this._renderErrors(sharedErrors, uniqueErrors);
    },

    _renderErrors: function(sharedErrors, uniqueErrors) {
        var $navItems = this._$jobsNav.find(".listItem");

        var findNavItem = function(positionId) {
            var $navItem = null;
            $.each($navItems, function() {
                if($(this).attr("data-listVal") == positionId)
                    $navItem = $(this);
            });

            return $navItem;
        };

        var navItemsWithErrors = [];
        for(var positionId in uniqueErrors) {
            var $navItem = findNavItem(positionId);
            navItemsWithErrors.push($navItem);
            uniqueErrors[positionId]["_navItem"] = $navItem;

            for(var errName in uniqueErrors[positionId]) {
                if(errName == "_navItem")
                    continue;

                var errVal = uniqueErrors[positionId][errName];
                errVal = errVal.replace(".", " ");
                errVal += "for " + $navItem.attr("data-listLabel").toLowerCase() + " position.";

                uniqueErrors[positionId][errName] = errVal;
                sharedErrors[positionId + "_" + errName] = errVal;
            }
        }

        this._formSaver.showErrors(sharedErrors);
        if(navItemsWithErrors.length == 0)
            return;

        navItemsWithErrors[0].trigger("click");

        for(var i = 0; i < navItemsWithErrors.length; i++)
            navItemsWithErrors[i].addClass("error");
    }
});